export default __webpack_public_path__ + "static/media/arrow_down.9ba24892.svg";